import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  findAllVehiclePageble,
  createVehicle,
  deleteVehicle,
  updateVehicle,
  deleteErrorVehicle,
} from '../../actions/vehicle';
import { findAllBrand } from '../../actions/brand';
import VehicleTable from '../Vehicle/VehicleTable';
import { HeaderTable } from '../../enums/VehicleEnums';
import { TableContainer } from '../Reusable/TableContainer';
import ModalForAddVehicle from '../Vehicle/ModalForAddVehicle';
import brand from '../../reducers/brand';

const VehicleList = () => {
  const dispatch = useDispatch();
  const vehicleReducer = useSelector((state) => state.vehicle);
  const brandReducer = useSelector((state) => state.brand);
  const userReducer = useSelector((state) => state.user);
  const vehicleModelReducer = useSelector((state) => state.vehicleModel)
  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorVehicle());
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleAdd = (vehicle) => {
    dispatch(createVehicle(vehicle, handlePreviewClose));
  };

  useEffect(() => {
    dispatch(findAllVehiclePageble((0, 8, [])));
  }, [dispatch, findAllVehiclePageble]);

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForVehicleTable}
        showModal={showModal}
      >
        <VehicleTable
          dispatch={dispatch}
          vehicleReducer={vehicleReducer}
          findAllVehiclePageble={findAllVehiclePageble}
          updateVehicle={updateVehicle}
          deleteVehicle={deleteVehicle}
          clearValidationErrors={clearValidationErrors}
          brandReducer={brandReducer}
        />
      </TableContainer>
      {show && (
        <ModalForAddVehicle
          vehicleReducer={vehicleReducer}
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
          brandReducer={brandReducer}
          userReducer={userReducer}
          vehicleModelReducer={vehicleModelReducer}
        />
      )}
    </>
  );
};

export default VehicleList;
